<klt-section title="Sector beta (β)">
  <div class="graph-box">
    <klt-graph
      height="380px"
      [loading]="loading"
      [options]="options"
      [titles]="titles"
      (filter)="runFilter($event)"
    >
    </klt-graph>
  </div>
</klt-section>
